// Remembers the location picked in the sidebar switcher.
// Stored in localStorage so it survives reloads, navigation and new tabs
// (sessionStorage was per tab, so a new tab opened on a different location).
// "All Businesses" is saved explicitly as ALL so it is not mistaken for
// "nothing saved yet".
const KEY = 'selectedBusinessId';
export const ALL = 'all';

function stores() {
  const out = [];
  try { if (typeof localStorage !== 'undefined') out.push(localStorage); } catch {}
  return out;
}

export function readSavedBusiness() {
  for (const store of stores()) {
    try {
      const value = store.getItem(KEY);
      if (value === ALL) return ALL;
      if (value && /^\d{1,10}$/.test(value)) return Number(value);
    } catch {}
  }
  try {
    const legacy = sessionStorage.getItem(KEY);
    if (legacy && /^\d{1,10}$/.test(legacy)) return Number(legacy);
  } catch {}
  return null;
}

export function saveBusiness(id) {
  const value = id ? String(Number(id)) : ALL;
  for (const store of stores()) {
    try { store.setItem(KEY, value); } catch {}
  }
  try { sessionStorage.setItem(KEY, value); } catch {}
}

export function clearSavedBusiness() {
  try { localStorage.removeItem(KEY); } catch {}
  try { sessionStorage.removeItem(KEY); } catch {}
}
